<dialog-window [title]="title" (close)="close()" [modal]="false" [focusOnCloseButton]="true" [full-height]="false">
    <div class="demo-message">
        <h3>Данный плейлист является демонстрационным.</h3>
        Вы можете купить <b class="ion pay"></b> пакет каналов <b>IPTV</b>, на нашем сайте, после регистрации <a
            href="/billing/?entry=registration" target="_blank">Nasharu.TV</a><br>
        Затем загрузить <b class="ion download"></b> в редактор, полученный плейлист. Либо любой другой плейлист, который у вас
        есть.<br>
        Почитайте Справку <b class="ion help"></b> к редактору, для эффективного пользования.
    </div>
</dialog-window>